/**
 * @file 通用ECharts图表组件
 * @description 封装ECharts，支持自动resize和销毁
 */
<template>
  <div ref="chartRef" class="base-chart"></div>
</template>

<script>
import * as echarts from "echarts";

export default {
  name: "BaseChart",
  props: {
    // 图表配置项
    option: {
      type: Object,
      default: () => ({})
    },
    // 图表高度
    height: {
      type: String,
      default: "400px"
    },
    // 是否自动resize
    autoResize: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      chartInstance: null,
      resizeHandler: null
    };
  },
  watch: {
    option: {
      handler(newOption) {
        if (this.chartInstance && newOption) {
          this.chartInstance.setOption(newOption, true);
        }
      },
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    this.dispose();
  },
  methods: {
    initChart() {
      if (!this.$refs.chartRef) return;
      
      this.chartInstance = echarts.init(this.$refs.chartRef);
      
      if (this.option && Object.keys(this.option).length > 0) {
        this.chartInstance.setOption(this.option);
      }

      if (this.autoResize) {
        this.resizeHandler = () => {
          this.chartInstance && this.chartInstance.resize();
        };
        window.addEventListener("resize", this.resizeHandler);
      }
    },
    // 更新图表配置
    setOption(option, notMerge = false) {
      if (this.chartInstance) {
        this.chartInstance.setOption(option, notMerge);
      }
    },
    // 获取图表实例
    getInstance() {
      return this.chartInstance;
    },
    // 手动resize
    resize() {
      this.chartInstance && this.chartInstance.resize();
    },
    // 销毁图表
    dispose() {
      if (this.resizeHandler) {
        window.removeEventListener("resize", this.resizeHandler);
        this.resizeHandler = null;
      }
      if (this.chartInstance) {
        this.chartInstance.dispose();
        this.chartInstance = null;
      }
    }
  }
};
</script>

<style scoped>
.base-chart {
  width: 100%;
  height: v-bind(height);
}
</style>
